export const tabKeys = {
  TRANSACTIONS: 'transactions',
  HISTORY: 'history',
  TRADING_RESULT: 'trading_result',
  STRATEGY_INFO: 'strategy_info',

  KEY_INDICATORS: 'key_indicators',
  BACKTESTING: 'backtesting',
  TRADING_CONDITIONS: 'trading_conditions',
  COMMENTS: 'comments',
};
